module.exports = __webpack_public_path__ + "media/country_flags/to-78081ba3.png";